import React from 'react';
export function Footer() {
  return <footer className="bg-darker border-t border-border py-10 px-6 text-center" data-id="element-101">
      <div className="text-[20px] font-black text-white mb-4" data-id="element-102">
        Fábrica de Contenido <span className="text-orange" data-id="element-103">con IA</span>
      </div>

      <div className="flex justify-center gap-6 mb-6 flex-wrap" data-id="element-104">
        <a href="#" className="text-[#888] no-underline text-[14px] transition-colors hover:text-orange" data-id="element-105">
          Política de Privacidad
        </a>
        <a href="#" className="text-[#888] no-underline text-[14px] transition-colors hover:text-orange" data-id="element-106">
          Términos de Uso
        </a>
        <a href="#" className="text-[#888] no-underline text-[14px] transition-colors hover:text-orange" data-id="element-107">
          Contacto
        </a>
      </div>

      <p className="text-[13px] text-[#888]" data-id="element-108">
        © 2026 Gean Ortiz. Todos los derechos reservados.
      </p>
    </footer>;
}